import React from 'react';
import ReactDOM from 'react-dom';

import ErrorCdSsoPanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const createSsoCdErrorPanelScreen = ({ message }) => {
  const domId = 'ssoCdErrorPanel';
  if (isSupportedBrowser()) {
    ReactDOM.render(
      <AuthScreenLayout>
        <ErrorCdSsoPanel message={message} />
      </AuthScreenLayout>,
      document.getElementById(domId)
    );
  } else {
    ReactDOM.render(<UnsupportedBrowsers />, document.getElementById(domId));
  }
};

window.createSsoCdErrorPanelScreen = createSsoCdErrorPanelScreen;
